export enum RadiologyProceduresType {
    Default = null,
    Received = 1,
    Completed = 2,
}
